export const STORE_ORDER = {
  get: "/orders/store",
  post: "/order/store",
};
